declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
    __gtag_calls__?: unknown[][];
  }
}

const GA4_ID = process.env.NEXT_PUBLIC_GA4_ID;

export function trackPageView(url: string) {
  if (typeof window === 'undefined' || !window.gtag || !GA4_ID) return;
  
  window.gtag('config', GA4_ID, {
    page_location: url,
  });
}

// Form progress event — fires abn_tenure_selected, NOT a conversion
// The real generate_lead conversion is fired by trackLeadConversion in trackConversion.ts
export function trackLeadGeneration(data: {
  amount: number;
  abn_tenure: string;
}) {
  if (typeof window === 'undefined') {
    return;
  }

  if (!GA4_ID || !window.gtag) {
    if (!window.__gtag_calls__) window.__gtag_calls__ = [];
    window.__gtag_calls__.push(['abn_tenure_selected', {
      value: data.amount,
      currency: 'AUD',
      abn_tenure: data.abn_tenure
    }]);
    return;
  }
  
  window.gtag('event', 'abn_tenure_selected', {
    value: data.amount,
    currency: 'AUD',
    abn_tenure: data.abn_tenure
  });
}

export function trackEvent(eventName: string, parameters?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.gtag) return;
  
  window.gtag('event', eventName, parameters);
}
